/**
 * Enum for error messages returned from BsUtil
 * @readonly
 * @enum {string}
 */
export var BsUtilErrorStatusMessages;
(function (BsUtilErrorStatusMessages) {
    BsUtilErrorStatusMessages["malformedMessage"] = "malformedMessage";
    BsUtilErrorStatusMessages["selectionNotFound"] = "selectionNotFound";
    BsUtilErrorStatusMessages["selectionNotAvailable"] = "selectionNotAvailable";
})(BsUtilErrorStatusMessages || (BsUtilErrorStatusMessages = {}));
//# sourceMappingURL=BsUtilStatusMessages.js.map